<template>
<!--
    <div>
        pjwt is: {{ pjwt }}
        authornot is: {{ authOrNot }}
        posts is: {{ posts }}
        id is: {{ id }}
    </div>
    -->
<div class="flex flex-col">

    <div v-if="authOrNot">
        <!--
        <div @click="getPosts" class="refreshButton">
            Refresh posts
        </div>
        -->
        <section class="text-gray-600 dark:text-gray-200 body-font dark:bg-slate-800">
            <div class="container px-5 py-24 mx-auto flex flex-col">
                <div class="flex flex-wrap -m-4">
                <div v-for="post in posts" :key="post._id" class="p-4 w-full xs:w-6/12 md:w-1/3">
                    <div class="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                    <!--<img class="lg:h-48 md:h-36 w-full object-cover object-center" src="https://dummyimage.com/720x400" alt="blog">-->
                    <div class="p-6">
                        <!--<h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">CATEGORY</h2>-->
                        <!--<div>{{ post.author }} - {{ post.createdAt }}</div>-->
                        <h1 class="title-font text-lg font-medium text-gray-900 dark:text-slate-50 mb-3">{{ post.title }}</h1>
                        <p v-if="post.text.length > 35" class="leading-relaxed mb-3">{{ post.text.slice(0, 35) }} ...</p>
                        <p v-else class="leading-relaxed mb-3">{{ post.text }}</p>
                        <div class="flex items-center flex-wrap ">
                        <a @click="openComments(post._id)" class="text-indigo-500 inline-flex items-center md:mb-2 lg:mb-0 cursor-pointer hover:text-indigo-900 dark:hover:text-indigo-100">More
                            <svg class="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M5 12h14"></path>
                            <path d="M12 5l7 7-7 7"></path>
                            </svg>
                        </a>
                        <span v-if="likedStuff.likedPosts.includes(post._id)" class="text-[#eb4034] mr-3 inline-flex items-center  ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200 dark:border-gray-400">
                            <!--<svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                            </svg>-->♥ {{ post.likes }} 
                        </span>
                        <span v-else  @click="likePost(post._id)" class="text-gray-400 mr-3 inline-flex items-center ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-200 dark:border-gray-400 cursor-pointer hover:text-[#eb4034]">
                            <!--<svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                            </svg>-->♡ {{ post.likes }} 
                        </span>
                        <span @click="openComments(post._id)" class="text-gray-400 inline-flex items-center leading-none text-sm cursor-pointer hover:text-gray-900 dark:hover:text-gray-200">
                            <svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                            <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                            </svg>{{ post.comments.length }}
                        </span>
                        </div>
                    </div>
                    </div>
                </div>
                <!--<button @click="snacc('Salud!')" class="text-white bg-green-500 border-0 py-2 px-8 focus:outline-none hover:bg-green-600 rounded text-lg">Snacc Yourself</button>-->
                </div>

                <div v-if="!postsLoading" class="mt-5 self-center">
                    <button @click="getPosts" class="text-white bg-green-500 border-0 py-2 px-8 focus:outline-none hover:bg-green-600 rounded text-lg">Load More</button>
                </div>
                <div v-else>
                    <img :src="loadingImage" alt="">
                </div>

            </div>
        </section>
    </div>
    <div v-else>
        <h3>
            Sign In to experience true fax
        </h3>
    </div>
    <div class="border border-solid border-green-500 text-xl font-medium rounded-lg bg-white opacity-0 transition-all w-11/12 bottom-3 fixed self-center pt-2 pb-2 hidden dark:bg-opacity-75 dark:text-gray-600" ref="snackbar">
        {{ navMessage }}
    </div>
</div>
</template>

<script>
const devServer = process.env.VUE_APP_PROD_SERVER || "http://localhost:3030" ;
export default {
    name: "FeedView",
    props: {
        id: String,
    },
    data() {
        return {
            posts: [],
            pjwt: {
                token: "",
                username: ""
            },
            authOrNot: false,
            likedStuff: {
                likedPosts: [],
                likedComments: []
            },
            postsLoading: true,
            loadingImage: require('../assets/Rolling-1s-200px.gif'),
            navMessage: "",
            page: 1,
            newposts: 0,
        }
    },
    async created() {
        this.fillJWT();
        await this.checkAuth();
        await this.getPosts();
        let c = 0;
        while(c < 1000) {
            await this.postsWatcher();
            c++;
        }
    },
    methods: {
        
        snacc: async function(message) {
            this.navMessage = message;
            //console.log("making the opacity to 1....");
            this.$refs.snackbar.style.display = "block";
            this.$refs.snackbar.style.opacity = 1;
            setTimeout(() => {
                this.$refs.snackbar.style.opacity = 0;
            }, 3000);
            setTimeout(() => {
                this.$refs.snackbar.style.display = "none";
            }, 3500);
            //console.log("turned the opacity to 0 again....");
        },


        fillJWT: async function() {
            this.pjwt.username = "joe";
            this.pjwt.token = this.id;
        },
         

        checkAuth: async function() {
            let respomse = await fetch(`${devServer}/api/auth/checkAuth/`, {headers: {"Content-Type": "application/json", "authorization": `Bearer ${this.pjwt.token}`, mode: "cors"}});
            let res = await respomse.json();
            this.pjwt.username = await res.username;
            this.authOrNot = await res.isAuthed;
            //console.log("auth is done with result: ", (await this.pjwt))
            let likedrespomse = await fetch(`${devServer}/api/posts/getlikedstuff/`, {
                headers: {"Content-Type": "application/json", "authorization": `Bearer ${this.pjwt.token}`, "username": this.pjwt.username},
                mode: "cors"
            });
            this.likedStuff = await likedrespomse.json();
            //this.snacc(await this.likedStuff);
            //console.log("checkauth function executed: ", respomse.status, likedrespomse.status);
            this.$emit("passJWTToParent", this.pjwt);
        },


        getPosts: async function() {
            this.postsLoading = true;
            let postsResponse;
            const getPostsHeaders = {
                "Content-Type": "application/json",
                "authorization": `Bearer ${this.pjwt.token}`,
                "page": this.page,
                "sortby": "lastadded",
                "newposts": this.newposts,
                mode: "cors"
            }

            // console.log("auth or not in getposts:feedview is: " + this.authOrNot);
            if(this.authOrNot) {
                postsResponse = await fetch(`${devServer}/api/posts/feed/`, { headers: getPostsHeaders });
                const resArray = await postsResponse.json();
                resArray.forEach(element => {
                    // console.log("res array element: " + element.text);
                    if(element.text) {
                        this.posts.push(element);
                    }
                    
                });
                // this.posts.push(...resArray);
                // console.log("received posts is: " + JSON.stringify(this.posts) + " and page is: " + this.page);
                if(resArray.length != 0) {
                    this.page++;
                }
            } else {
                this.posts = [{}];
            }
            this.postsLoading = false;
        },

        /*
        checkLiked: async function( postid) {
            console.log("liked posts is: ", JSON.parse(JSON.stringify(this.likedStuff.likedPosts)));
            console.log("post id is: ", postid.trim());
            console.log("value of includes method is: ", this.likedStuff.likedPosts.includes(postid));
        },
        */

        openComments: async function(postid) {
            // open comments section, load last 5 comments with a more button
            //console.log("opening comments for post id: ", postid);
            //this.$router.push({path: `/post/${postid}${this.pjwt.token}`, query: {comingFrom: "dashboard"}});
            this.$router.push({path: `/post/${postid}${this.pjwt.token}`});
        },

        likePost: async function(postid) {
            this.likedStuff.likedPosts.push(postid);
            this.posts.filter((el) => {return el._id == postid})[0].likes++;
            const respomse = await fetch(`${devServer}/api/posts/like`, {
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${this.pjwt.token}`,
                    'postid': postid,
                    'username': this.pjwt.username
                },
                mode: 'cors',
            });
            if(respomse.status == 200) {
                this.snacc('Liked the post');
            } else {
                this.snacc('Post Liking Error')
            }
        },

        postsWatchBackendCall: async function() {
            let respomse = await fetch(`${devServer}/api/posts/watchposts/`, {headers: {"Content-Type": "application/json", "authorization": `Bearer ${this.pjwt.token}`, mode: "cors"}});
            return respomse;
        },


        postsWatcher: async function() {
            //this.snacc("postswatcher started again");
            let respomse = await this.postsWatchBackendCall();
            let res = await respomse.json();
            if(respomse.status == 200) {
                // code to run if a new post was added while watching for two minutes
                // prepend the new post
                this.posts.splice(0, 0, res.fullDocument);
                this.newposts++;
                this.snacc("New Post!");
            } else if(respomse.status == 400) {
                // code to execute if no post was added during watching
                //this.postsWatcher();
                // recurse till base case, new post/200 is received
                this.snacc("No posts received!");
            }
        },

    }
}
</script>

